import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';
import { Storage } from 'lib/storage';
import { Form, Input, Button, Checkbox } from 'antd';
import "./LoginView.scss";


@inject('commonStore')
@observer
class LoginView extends Component {

  onLogin = (values) => {
    this.props.commonStore.disLoginInfo(values);
  };

  render() {
    const layout = {
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
    };
    const tailLayout = {
      wrapperCol: { offset: 8, span: 16 },
    };
    const tailLayout2 = {
      wrapperCol: { offset: 1, span: 20 },
    };
    
    return (
      <Fragment>
        <br />
        
        <div className = 'logo_2'>
					<Link to = "/login">YUJIN S&A</Link>
				</div>
   
      {/* 로그인 이미지 
       <img
          alt={'logo'}
          src={require('../../img/yujinmallImg.png')}
          width="50%" 
          style={{ margin: '0 auto 20px',minWidth: '460px',height:'100%'}}
        />
         */}
        <br />

        <Form
          style={{ width: '50%', border:'1px solid #efefef', padding :'2rem 4rem 0.5rem', margin : '0 auto' }}
          {...layout}
          name="basic"
          onFinish={this.onLogin}
          initialValues={{
            ceCd: (Storage.local.get("yujin_ceCd") !== undefined && Storage.local.get("yujin_ceCd") !== null)
                    ? Storage.local.get("yujin_ceCd") : '',
            cePw: (Storage.local.get("yujin_cePw") !== undefined && Storage.local.get("yujin_cePw") !== null)
                    ? Storage.local.get("yujin_cePw") : '',
            remember: (Storage.local.get("yujin_ceCd") !== undefined && Storage.local.get("yujin_ceCd") !== null
                    && Storage.local.get("yujin_cePw") !== undefined && Storage.local.get("yujin_cePw") !== null)
                    ? true : false
          }}
        >
          <div>
            <Form.Item
              label="아이디"
              name="ceCd"
              rules={[{ required: true, message: '아이디를 입력하세요.' }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
                className="log_pw_inw"
              label="비밀번호"
              name="cePw"
              rules={[{ required: true, message: '비밀번호를 입력하세요.' }]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item {...tailLayout} name="remember" valuePropName="checked">
              <Checkbox>아이디, 비밀번호 저장</Checkbox>
            </Form.Item>   
          </div>
          <Form.Item {...tailLayout2}>
            <Button
              className="log_btn"
              type="primary" 
              htmlType="submit"
            >
              로그인
            </Button>
          </Form.Item>
        </Form>
      </Fragment>
    );
  }

}

export default withRouter(LoginView);
